// api/catalogue.js
// The product catalogue: what is on sale, what it costs, and what it grants.
//
// Prices and product codes are read from the server and nowhere else. They used
// to live in four hand-maintained copies of a BUNDLE_CONFIG object plus a set of
// hardcoded rupee fallbacks, which is how a page could show one price while
// checkout charged another. There are deliberately no fallbacks here: a price
// the server cannot supply is null, and a caller that has no price shows none
// rather than inventing one.
import apiClient from "./client";

export const catalogueApi = {
  // Active, sellable products. A product missing from this list cannot be
  // bought; the server applies the same rule at checkout.
  getProducts: () => apiClient.get("/api/products"),

  // Published bundles with their sales copy and their active products.
  getBundles: () => apiClient.get("/api/bundles"),
  getBundle: (slug) => apiClient.get(`/api/bundles/${slug}`),
};

// The catalogue keys bundles by slug. The workbook routes have always used
// "free" in the URL for the bundle the catalogue calls "core", and those URLs
// are public, so the translation happens here rather than by renaming the
// bundle or breaking every saved link.
export const bundleSlugForRoute = (routeParam) =>
  routeParam === "free" ? "core" : routeParam;

export const routeForBundleSlug = (slug) => (slug === "core" ? "free" : slug);

// The product a page should sell for a bundle.
//
// A bundle can carry two products: the workbooks on their own, and the video
// course that includes them. They are priced apart, and selling the wrong one
// is the exact bug this whole restructure exists to prevent, so the choice is
// explicit at every call site rather than inferred from a string prefix.
//   workbookProductFor  the workbooks alone (no video course)
//   courseProductFor    the course, which also grants the workbooks
export const workbookProductFor = (bundle) =>
  bundle?.products?.find((p) => !p.hasCourse) ?? null;

export const courseProductFor = (bundle) =>
  bundle?.products?.find((p) => p.hasCourse) ?? null;

// Rupees for display. Returns null when there is no price to show, so callers
// can render "coming soon" instead of a zero.
export const rupees = (price) =>
  price && price.paise > 0 ? price.rupees : null;
